import { gql } from 'graphql-request'

export const GET_PROFILE_MINI = gql`
  query GET_PROFILE_MINI {
    getProfileMini {
      data {
        id
        coins
        language
        username
        imgUser
        privacy {
          invisibleVisitor
        }
      }
    }
  }
`

export const GET_PROFILE = gql`
  query GET_PROFILE {
    getProfile {
      data {
        id
        googleId
        appleId
        appleToken
        country
        username
        phone
        invitationCode
        imgUser
        gender
        birthday
        coins
        points
        pointsRisk
        beans
        utc
        biography
        language
        following
        followers
        userSuperFan
        blockeds
        fpsLive
        userQualityLiveType
        canOpenVideo
        isAgencyAudio
        isHostPro
        isHostVerified
        showTime
        showTimePosition
        liveHouseCountry
        liveCountryInitial
        liveCountryFinal
        liveHouseGlobal
        liveGlobalInitial
        liveGlobalFinal
        canCloseLive
        canApplyShadowBan
        countryCode {
          id
          name
          currency
          ddi
          extensionDomain
          iconCountryCode
          region
          codeIsoAlpha2
          codeIsoAlpha3
          codeIsoNumeric
        }
        userDetail {
          id
          alreadyChangedBirthday
          alreadyChangedCountry
          alreadyChangedSex
          familyId
        }
        privacy {
          invisibleGiftGiver
          invisibleVisitor
          showFollowers
          showFollowing
          showMyGiftGivers
          showRechargeRanking
          showSpectatorRanking
          showStreamerRanking
          showSuperFans
          showMyStatus
        }
        userDetailSuperFan {
          createdAt
          id
          imgFanGroup
          tagFanGroup
          dateLastNotification
          updatedAt
          userId
        }
        agencyUser {
          isOwner
          accept
          active
          agencyId
          agency {
            id
            name
            imgAgency
            emailAddress
            createdAt
            user {
              id
              username
              imgUser
            }
          }
          createdAt
          dateAccept
          dateLastActive
          dateLastDelete
          dateRejected
          dateReleased
          dateRequestLeaveAgency
          deleted
          id
          rejected
          released
          updatedAt
          userId
        }
        agency {
          id
          countryCodeId
          countryCode {
            id
            name
          }
          agencyCode
          imgAgency
          name
          utc
          document
          homeAddress
          emailAddress
          whatsapp
          instagram
          facebook
          imgPersonalDocumentFront
          imgPersonalDocumentBack
          typeWithdrawalAgency
          points
          coinsForSale
          levelAgencyExperience
          comission
          isReseller
          active
          deleted
        }
        withdrawalMethodDataUser {
          id
          bankAccountNumber
          bankAgencyNumber
          bankDocument
          bankName
          bankNumber
          binanceKey
          binding
          dateBinding
          createdAt
          paypalEmail
          receivedKey
          receivedName
          updatedAt
          withdrawalMethodId
          typeWithdrawalMethodDataUserPixType
          withdrawalMethod {
            id
            iconWithdrawalMethod
            name
            taxPayment
            timePayment
            typeWithdrawalMethodTypePayment
            typeWithdrawalMethodTax
          }
        }
        userFace {
          id
          confidence
          createdAt
          faceId
          firstAccount
          secondaryAccount
          updatedAt
          userFirstAccountId
          userId
        }
        paymentAgent {
          id
          countryCodeId
          createdAt
          online
          scorePayment
          updatedAt
          userId
        }
        userPhotos {
          imgUserPhoto
          active
          position
        }
        userLevel {
          levelSpectatorId
          levelSpectator {
            id
            gradientColor
            emblem
            level
          }
          levelHostId
          levelHost {
            gradientColor
            emblem
            level
          }
        }
      }
    }
  }
`

export const GET_USER_COINS = gql`
  query GET_USER_COINS {
    getUserCoins {
      data {
        coins
      }
    }
  }
`

export const GET_ANY_PROFILE = gql`
  query GET_ANY_PROFILE($id: Int!) {
    getAnyProfile(id: $id) {
      data {
        id
        username
        country
        imgUser
        gender
        birthday
        coins
        points
        beans
        online
        utc
        tasks
        biography
        following
        followers
        userSuperFan
        onlineLive
        onlineOtherLive
        isHostPro
        isHostVerified
        showTime
        showTimePosition
        liveHouseCountry
        liveCountryInitial
        liveCountryFinal
        liveHouseGlobal
        liveGlobalInitial
        liveGlobalFinal
        agencyUser {
          isOwner
          accept
          active
          agencyId
          agency {
            id
            name
            imgAgency
            emailAddress
            createdAt
            user {
              id
              username
              imgUser
            }
          }
          createdAt
          dateAccept
          dateLastActive
          dateLastDelete
          dateRejected
          dateReleased
          deleted
          id
          rejected
          released
          updatedAt
          userId
        }
        agency {
          id
          countryCodeId
          countryCode {
            id
            name
          }
          agencyCode
          imgAgency
          name
          utc
          document
          homeAddress
          emailAddress
          whatsapp
          instagram
          facebook
          imgPersonalDocumentFront
          imgPersonalDocumentBack
          typeWithdrawalAgency
          points
          coinsForSale
          levelAgencyExperience
          comission
          isReseller
          active
          deleted
        }
        privacy {
          invisibleGiftGiver
          invisibleVisitor
          showFollowers
          showFollowing
          showMyGiftGivers
          showRechargeRanking
          showSpectatorRanking
          showStreamerRanking
          showSuperFans
          showMyStatus
        }
        userDetailSuperFan {
          createdAt
          id
          imgFanGroup
          tagFanGroup
          updatedAt
          userId
        }
        userPhotos {
          imgUserPhoto
          active
          position
        }
      }
    }
  }
`

export const GET_USERS = gql`
  query GET_USERS(
    $take: Int
    $skip: Int
    $agencyId: Int
    $username: String
    $userToSearchId: Int
    $gender: String
  ) {
    getUsers(
      take: $take
      skip: $skip
      agencyId: $agencyId
      username: $username
      userToSearchId: $userToSearchId
      gender: $gender
    ) {
      data {
        id
        country
        username
        imgUser
        gender
        birthday
        coins
        points
        beans
        biography
        userLevel {
          levelSpectatorId
          levelSpectator {
            id
            gradientColor
            emblem
            level
          }
          levelHostId
          levelHost {
            gradientColor
            emblem
            level
          }
        }
        userBadge {
          id
          typeLocalBadge
          inUse
          badge {
            id
            iconBadge
            typeBadge
          }
        }
        userVip {
          id
          vipId
          expiresIn
          vip {
            id
            vipLevel
            iconVip
          }
        }
      }
    }
  }
`

export const UPDATE_PROFILE = gql`
  mutation UPDATE_PROFILE(
    $username: String
    $biography: String
    $country: String
    $gender: String
    $birthday: String
    $imgUser: String
  ) {
    updateProfile(
      username: $username
      biography: $biography
      country: $country
      gender: $gender
      birthday: $birthday
      imgUser: $imgUser
    ) {
      status
    }
  }
`

export const REMOVE_USER_PHOTO = gql`
  mutation REMOVE_USER_PHOTO($position: Int!) {
    removeUserPhoto(position: $position) {
      error
      status
      data
    }
  }
`
